/* AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2024 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { IDiagnosticReport } from "../../types/studies";
import { getHumanName } from "../../utils/format";
import { BigText } from "../Displays/BigText";

interface IDiagnosticReportFooter {
  reportDetail?: IDiagnosticReport;
}

export const DiagnosticReportFooter: FC<IDiagnosticReportFooter> = ({
  reportDetail,
}) => {
  const { t } = useTranslation("modal");
  return (
    <div className="flexbox pl-1">
      <div className="flexbox flex-auto p-r-xxs">
        <div
          className="message_lable_detail p-r-xs font-weight-bold"
          style={{ width: 95 }}
        >
          {t("modal:diagnostic_report.reported_by")}:
        </div>
        {reportDetail?.principalResultInterpreter && (
          <BigText
            maxWidth={120}
            text={getHumanName(reportDetail?.principalResultInterpreter)}
          />
        )}
      </div>
      <div className="flexbox flex-auto p-r-xxs">
        <div
          className="message_lable_detail p-r-xs font-weight-bold"
          style={{ width: 110 }}
        >
          {t("modal:diagnostic_report.transcribed_by")}:
        </div>
        {reportDetail?.transcriptionist && (
          <BigText
            text={getHumanName(reportDetail?.transcriptionist)}
            maxWidth={120}
          />
        )}
      </div>
      <div className="flexbox flex-auto p-r-xxs">
        <div
          className="message_lable_detail p-r-xs font-weight-bold"
          style={{ width: 85 }}
        >
          {t("modal:diagnostic_report.verified_by")}:
        </div>
        {reportDetail?.assistantResultInterpreters && (
          <BigText
            maxWidth={120}
            text={reportDetail?.assistantResultInterpreters
              ?.map(getHumanName)
              .join(", ")}
          />
        )}
      </div>
    </div>
  );
};
